import type { GlobalFieldReference, IconsGrid } from '@ps/web-martech-cms-types';
import type { IconsGridBlock } from '@ps/web-martech-cms-types/ProspectHomepageSlide';
import classNames from 'clsx';
import React from 'react';

import { CMSIconsGrid, CMSReference, useCMSReference } from '@swf/cms';

import styles from './CardContentItem.scss';

interface Props {
  item: GlobalFieldReference | IconsGridBlock;
  className?: string;
}

const CardContentItem: React.FC<Props> = ({ item, className }) => {
  const [[type, value]] = Object.entries(item);
  const iconsGrid = useCMSReference<IconsGrid>(value.reference?.[0]);
  const itemClassNames = [styles.contentItem];

  if (type === 'cta') {
    value.grow = true;
    itemClassNames.push(styles.blockCta);
  } else if (type === 'html') {
    itemClassNames.push(styles.blockHtml);
  } else if (type === 'icons_grid' && iconsGrid) {
    return (
      <div className={classNames(styles.contentItem, className)}>
        <CMSIconsGrid {...iconsGrid} wrapperClassName={styles.wrapper} />
      </div>
    );
  }

  value.className = classNames(itemClassNames, className);

  return <CMSReference {...(item as GlobalFieldReference)} />;
};

export default CardContentItem;
